
interface Artist {
  name: string;
  avatar: string;
}

interface StickyCTAProps {
  artist: Artist;
  onTip: () => void;
  onJoinMembership: () => void;
  onBuyLatest: () => void;
}

export default function StickyCTA({ artist, onTip, onJoinMembership, onBuyLatest }: StickyCTAProps) {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-40">
      <div className="flex items-center gap-3">
        <img
          src={artist.avatar}
          alt={artist.name}
          className="w-10 h-10 rounded-full object-cover"
        />
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-gray-900 text-sm truncate">
            {artist.name}
          </p>
          <p className="text-xs text-gray-500">Support this artist</p>
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={onTip}
            className="bg-gray-100 hover:bg-gray-200 text-gray-900 font-semibold py-2 px-3 rounded-lg transition-colors whitespace-nowrap text-sm"
          >
            Tip
          </button>
          <button
            onClick={onJoinMembership}
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2 px-3 rounded-lg transition-colors whitespace-nowrap text-sm"
          >
            Join
          </button>
          <button
            onClick={onBuyLatest}
            className="bg-gray-900 hover:bg-gray-800 text-white font-semibold py-2 px-3 rounded-lg transition-colors whitespace-nowrap text-sm"
          >
            Buy
          </button>
        </div>
      </div>
    </div>
  );
}
